import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  isWhiteNav: boolean = false;
  isWhiteNavState: BehaviorSubject<boolean> = new BehaviorSubject(this.isWhiteNav);

  constructor() { }

  setWhiteNav(white: boolean) {
    this.isWhiteNav = white;
    this.isWhiteNavState.next(white);
  }

  getWhiteNav() {
    return this.isWhiteNav;
  }
}
